import React from 'react';
import { FooterLink2 } from '../data/footerLinks';
import { Link } from 'react-router-dom';
import { FaInstagram, FaGithub, FaLinkedin } from 'react-icons/fa';
import { contactPoints } from '../data/contactPoints';
import Logo from '../assets/images/bcc_logo.jpeg';

const tickerWords = ['BUILD', 'SHIP', 'SCALE', 'INNOVATE', 'DESIGN', 'DEVELOP', 'LAUNCH', 'OPTIMIZE'];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ background: '#1d1d1f', color: '#f5f5f7' }}>
      
      {/* ── Scrolling Ticker ── */}
      <div className="overflow-hidden py-5" style={{ borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
        <div className="ticker-track" style={{ animationDuration: '20s' }}>
          {[...tickerWords, ...tickerWords, ...tickerWords, ...tickerWords].map((word, i) => (
            <div key={i} className="flex items-center gap-8 flex-shrink-0 px-4">
              <span className="text-xs font-extrabold tracking-[0.2em] uppercase"
                    style={{ 
                      background: 'linear-gradient(135deg, rgba(0,212,255,0.3), rgba(168,85,247,0.3))',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text',
                    }}>
                {word}
              </span>
              <span className="w-1 h-1 rounded-full" style={{ background: 'rgba(0, 212, 255, 0.3)' }} />
            </div>
          ))}
        </div>
      </div>

      {/* ── Main Footer ── */}
      <div className="section-container px-6 lg:px-8 pt-16 pb-12">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">

          {/* Brand Column */}
          <div className="lg:w-[30%]">
            <Link to="/" className="flex items-center gap-2.5 mb-5">
              <img src={Logo} alt="Bombay Coding Consultancy LLP" className="h-10 w-10 object-cover rounded-xl" />
              <span className="text-lg font-bold tracking-tight">Bombay Coding Consultancy LLP</span>
            </Link>
            <p className="text-sm leading-relaxed mb-6 max-w-xs" style={{ color: 'rgba(255,255,255,0.4)' }}>
              Transforming ambitious ideas into scalable digital realities. We architect premium web, mobile, and AI solutions for modern product and enterprise teams.
            </p>

            {/* Social Icons */}
            <div className="flex items-center gap-3 mb-8">
              {[
                { icon: FaInstagram, href: contactPoints.instagram, label: 'Instagram', hoverColor: 'rgba(244,114,182,0.8)' },
                { icon: FaLinkedin, href: contactPoints.linkedin, label: 'LinkedIn', hoverColor: 'rgba(0,212,255,0.8)' },
                { icon: FaGithub, href: contactPoints.github, label: 'GitHub', hoverColor: 'rgba(255,255,255,0.8)' },
              ].map((social, i) => (
                <a key={i}
                   href={social.href}
                   target="_blank"
                   rel="noopener noreferrer"
                   className="flex items-center justify-center w-10 h-10 rounded-full transition-all duration-300 group hover:scale-110"
                   style={{ 
                     background: 'rgba(255,255,255,0.05)',
                     color: 'rgba(255,255,255,0.4)',
                   }}
                   onMouseEnter={(e) => {
                     e.currentTarget.style.color = social.hoverColor;
                     e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                     e.currentTarget.style.boxShadow = `0 0 20px ${social.hoverColor.replace('0.8', '0.2')}`;
                   }}
                   onMouseLeave={(e) => {
                     e.currentTarget.style.color = 'rgba(255,255,255,0.4)';
                     e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
                     e.currentTarget.style.boxShadow = 'none';
                   }}
                   aria-label={social.label}
                >
                  <social.icon size={16} />
                </a>
              ))}
            </div>

            {/* Corporate/Legal Headquarters */}
            <div className="space-y-4 border-t border-white/5 pt-6 mt-4">
              <div className="flex items-center gap-2">
                <span className="text-[10px] uppercase font-bold tracking-wider" style={{ color: 'rgba(255,255,255,0.3)' }}>GSTN</span>
                <span className="text-xs font-mono font-medium tracking-widest" style={{ color: 'rgba(255,255,255,0.5)' }}>27ABGFB7663R1ZL</span>
              </div>
              
              <div>
                <h5 className="text-[10px] uppercase font-bold tracking-widest mb-1.5" style={{ color: 'rgba(255,255,255,0.5)' }}>
                  Headquarters
                </h5>
                <p className="text-xs leading-relaxed max-w-[260px]" style={{ color: 'rgba(255,255,255,0.45)' }}>
                  1/11, Sai Skrupa Seva Society, Ghartan Pada No. 2, Suyog Nagar, Sant Mirabai Marg, Dahisar East, Mumbai – 400068
                </p>
              </div>
            </div>
          </div>

          {/* Link Columns */}
          <div className="flex-1 grid grid-cols-2 md:grid-cols-4 gap-8 mt-10 lg:mt-0">
            {FooterLink2.map((section, index) => (
              <div key={index}>
                <h4 className="text-xs font-semibold uppercase tracking-[0.12em] mb-4"
                    style={{ color: 'rgba(255,255,255,0.3)' }}>
                  {section.title}
                </h4>
                <ul className="space-y-2.5">
                  {section.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <Link
                        to={link.url || link.link || '/'}
                        className="text-sm transition-all duration-300 hover:translate-x-1 inline-block"
                        style={{ color: 'rgba(255,255,255,0.45)' }}
                        onMouseEnter={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.9)'}
                        onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.45)'}
                      >
                        {link.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Gradient Divider ── */}
      <div className="h-px mx-6 lg:mx-8"
           style={{ 
             background: 'linear-gradient(90deg, transparent, rgba(0,212,255,0.2), rgba(168,85,247,0.2), transparent)',
           }} />

      {/* ── Bottom Bar ── */}
      <div className="section-container px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs" style={{ color: 'rgba(255,255,255,0.25)' }}>
            © {currentYear} Bombay Coding Consultancy LLP. All Rights Reserved.
          </p>
          <div className="flex items-center gap-6">
            {[
              { to: '/termsandcondition', label: 'Terms & Conditions' },
              { to: '/privacypolicy', label: 'Privacy Policy' },
              { to: '/cookiepolicy', label: 'Cookie Policy' },
            ].map((item, i) => (
              <Link key={i}
                    to={item.to}
                    className="text-xs transition-colors duration-300"
                    style={{ color: 'rgba(255,255,255,0.25)' }}
                    onMouseEnter={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.6)'}
                    onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.25)'}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
